import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import {FormMaterialTextField} from 'shared-react/formik/FormikMaterialFields';
import {TextField} from "@material-ui/core";

const LoginSchema = Yup.object().shape({
    username: Yup.string()
        .required('Šis laukas negali būti tuščias'),
    password: Yup.string()
        .required('Šis laukas negali būti tuščias'),
});

function LoginForm({onRequestUserLogin, isSubmitting}) {
    return (
        <Card>
            <CardContent>
                <Formik
                    initialValues={{ username: '', password: '' }}
                    validationSchema={LoginSchema}
                    onSubmit={(values) => {
                        onRequestUserLogin(values.username, values.password);
                    }}
                >
                    {() => (
                        <Form autoComplete="on">
                            <Field
                                id="username"
                                name="username"
                                label="Prisijungimo vardas"
                                fullWidth
                                autoComplete="username email"
                                margin="normal"
                                component={FormMaterialTextField}
                            />
                            <Field
                                id="password"
                                type="password"
                                name="password"
                                label="Slaptažodis"
                                fullWidth
                                autoComplete={'current-password'}
                                margin="normal"
                                component={FormMaterialTextField}
                            />
                            <Button fullWidth variant="contained" color="primary" type="submit" disabled={isSubmitting} style={{
                                marginTop: 16
                            }}>
                                Prisijungti
                            </Button>
                        </Form>
                    )}
                </Formik>
            </CardContent>
        </Card>
    );
}

export default LoginForm;